<template>
  <v-app light>
    <v-app-bar app height="240" width="1080" :src="getBannerSrc()" extended>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <template v-slot:img="{ props }">
        <v-img v-bind="props"></v-img>
      </template>
    </v-app-bar>
    <v-content>
      <v-container fluid v-show="showMainItem">
        <v-row justify="center" class="pb-12" align="end" style="height: 400px">
          <div class="primary--text display-3 font-weight-bold">請選擇電子發票類型</div>
        </v-row>
        <v-row v-for="row_n in Math.ceil(invoiceTypes.length / 3)" :key="`row_key_${row_n}`">
          <v-col cols="1.5" />
          <v-col v-for="col_invoiceItem in invoiceTypes.slice((row_n - 1) * 3, row_n * 3)"
            :key="`col_key_${col_invoiceItem.name}`" cols="3">
            <v-card class="mx-auto" max-width="400" @click="doInvoice(col_invoiceItem.name)" align="center" flat>
              <v-img height="190" width="190" :src="`static/image/${col_invoiceItem.image}`"
                :style="`border:2px solid ${$vuetify.theme.themes.light.primary}; border-radius: 10%`">
              </v-img>
              <v-card-text class="display-1 font-weight-bold" align="center">
                <div>{{ col_invoiceItem.label }}</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="1.5" />
        </v-row>
      </v-container>
      <v-container fluid v-show="showVatInput">
        <v-row style="height: 1000px" align="end">
          <v-card class="mx-auto" max-width="800" align="center" flat>
            <v-card-text class="display-2 font-weight-bold mt-10" align="center">
              <div>請輸入公司統一編號</div>
              <v-text-field v-model="inputBuyerVat" class="mt-10 display-3 pa-10" height="120"
                :rules="[rules.vatLength]" :counter="8" outlined color="primary" flat dense type="number"
                readonly></v-text-field>
            </v-card-text>
            <v-container>
              <v-row v-for="(rowItem, rowIndex) in keyboard" :key="`keyboard-row-${rowIndex}`">
                <v-col></v-col>
                <v-col v-for="(colItem, colIndex) in rowItem" :key="`keyboard-col-${rowIndex}-${colIndex}`">
                  <v-btn height="100" class="display-2 font-weight-bold" color="primary"
                    @click="keyIn(colItem, 'inputBuyerVat')" x-large block outlined>{{ colItem }}
                  </v-btn>
                </v-col>
                <v-col></v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-row>
      </v-container>
      <v-container fluid v-show="showDonateCodeInput">
        <v-row style="height: 1000px" align="end">
          <v-card class="mx-auto" max-width="800" align="center" flat>
            <v-card-text class="display-2 font-weight-bold mt-10" align="center">
              <div>請輸入愛心碼或由左下方掃描條碼</div>
              <v-text-field v-model="inputDonateCode" class="mt-10 display-3 pa-10" height="120" :counter="8" outlined
                color="primary" flat dense type="number" readonly></v-text-field>
            </v-card-text>
            <v-container>
              <v-row v-for="(rowItem, rowIndex) in keyboard" :key="`keyboard-row-${rowIndex}`">
                <v-col></v-col>
                <v-col v-for="(colItem, colIndex) in rowItem" :key="`keyboard-col-${rowIndex}-${colIndex}`">
                  <v-btn height="100" class="display-2 font-weight-bold" color="primary"
                    @click="keyIn(colItem, 'inputDonateCode')" x-large block outlined>{{ colItem }}
                  </v-btn>
                </v-col>
                <v-col></v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-row>
      </v-container>
      <v-container fluid v-show="showScan">
        <v-row style="height: 1000px" align="end">
          <v-card class="mx-auto" max-width="800" align="center" flat>
            <v-img height="412" width="247" src="static/image/ill_invoice_carrier.png">
            </v-img>
            <v-card-text class="display-2 font-weight-bold mt-10" align="center">
              <div>請掃描載具條碼</div>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
      <v-container fluid v-show="showInProcess">
        <v-row style="height: 400px" align="end">
          <v-card class="mx-auto" max-width="800" align="center" flat>
            <v-card-text class="display-2 font-weight-bold mt-10" align="center">
              <div>作業處理中，請稍後</div>
              <br />
              <v-progress-linear indeterminate height="30" color="primary"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </v-content>
    <v-footer padless app color="white">
      <v-container v-show="!showMainItem" fluid>
        <v-row class="pa-0">
          <v-col class="pr-0 pl-0">
            <v-btn height="70" class="display-1 font-weight-bold" color="primary" @click="back" x-large block
              outlined>返回上一步
            </v-btn>
          </v-col>
          <v-col class="pr-0 pl-0">
            <v-btn height="70" class="display-1 font-weight-bold" color="primary" @click="goNext" x-large block
              depressed :disabled="!(inputBuyerVat.length === 8 || inputBuyerVat.length === 0) || isLockSubmit">
              確定
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'InvoicePage',
  components: {},
  props: {},
  data: () => ({
    showMainItem: true,
    showScan: false,
    showVatInput: false,
    showInProcess: false,
    showDonateCodeInput: false,
    rules: {
      vatLength: (v) => v.toString().length === 8 || '請輸入8位數統一號碼',
    },
    isLockSubmit: false,
    inputBuyerVat: '',
    inputDonateCode: '',
    keyboard: [
      ['7', '8', '9'],
      ['4', '5', '6'],
      ['1', '2', '3'],
      ['<-', '0', 'C'],
    ],
    invoiceTypes: [
      {
        name: 'personal',
        label: '列印發票',
        image: 'ic_personal_receipt.png',
      },
      {
        name: 'company',
        label: '統一編號',
        image: 'ic_company_receipt.png',
      },
      {
        name: 'carrier',
        label: '存入載具',
        image: 'ic_personal_receipt_v.png',
      },
      {
        name: 'donate',
        label: '愛心捐贈',
        image: 'ic_donate_receipt.png',
      },
    ],
  }),
  methods: {
    getBannerSrc() {
      const setting = this.$store.getters.storeSetting;
      if (setting.kioskHomePageBanner) {
        return setting.kioskHomePageBanner.url + setting.kioskHomePageBanner.file_name;
      }
      return '';
    },
    doInvoice(type) {
      this.showMainItem = false;
      switch (type) {
        case 'personal':
          this.goNext();
          break;
        case 'donate':
          this.showDonateCodeInput = true;
          this.scanQRCode(true, type, this.goNext);
          break;
        case 'carrier':
          this.showScan = true;
          this.scanQRCode(true, type, this.goNext);
          break;
        case 'company':
          this.showVatInput = true;
          break;
        default:
      }
    },
    keyIn(char, field) {
      if (char === '<-') {
        const strLength = this[field].length;
        this[field] = this[field].substring(0, strLength - 1);
        return;
      }
      if (char === 'C') {
        this[field] = '';
        return;
      }
      this[field] += char;
    },
    handleDialogClose() {
      this.dialogPayment = false;
    },
    goNext() {
      this.isLockSubmit = true;
      if (this.inputBuyerVat) this.$store.dispatch('setOrderContent', { invoiceBuyerVat: this.inputBuyerVat });
      if (this.inputDonateCode) this.$store.dispatch('setOrderContent', { invoiceDonateCode: this.inputDonateCode });
      const next = this.$store.getters.nextStatusText;
      // console.log('next', next);
      this.$router.push(next);
    },
    back() {
      this.scanQRCode(false);
      this.isLockSubmit = false;
      if (this.showMainItem) {
        this.$router.replace('/ORDER');
      } else {
        this.showMainItem = true;
        this.showScan = false;
        this.showVatInput = false;
      }
    },
  },
  mounted() {
    this.$store.dispatch('setStatus', 'INVOICE');
  },
};
</script>
<style>
.v-input input {
  max-height: none;
  letter-spacing: 16px;
}
</style>
